<template>
  <BaseWrapper :loading="loading">
    <div class="flex justify-end mb-4">
      <BaseSelect
        :shadow="false"
        :options="[
          {
            key: 'diproses_gudang_pengeluaran',
            label: 'Diproses Gudang Pengeluaran',
            value: 'diproses_gudang_pengeluaran'
          },
          {
            key: 'diproses_gudang_pengiriman',
            label: 'Diproses Gudang Pengiriman',
            value: 'diproses_gudang_pengiriman'
          },
          {
            key: 'ada_susulan',
            label: 'Ada Susulan',
            value: 'ada_susulan'
          },
          {
            key: 'selesai',
            label: 'Selesai',
            value: 'selesai'
          }
        ]"
        v-model="filter.status"
        @change="loadOrders"
      />
    </div>
    <Datatable :columns="columns">
      <template #tbody="{ classes }">
        <tr v-for="order in orders.data" :key="order.id" :class="[classes.tr, 'bg-white cursor-pointer hover:bg-gray-50']" @click="$router.push({ name: 'gudang.reimbursement.create', params: { id: getOrder(order).id } })">
          <td :class="classes.td">
            <OrderCodeLabel :order="getOrder(order)" />
            <OrderDateLabel
              :order="order"
              class="text-xs text-gray-500"
            />
          </td>
          <td :class="classes.td">
            {{ getOrder(order).attributes.origin_office_code }}
          </td>
          <td :class="classes.td">
            {{ getOrder(order).attributes.reimbursement_qty }}
          </td>
          <td :class="[classes.td, 'text-center']">
            <BaseBadge color="blue">{{ getOrder(order).attributes.reimbursement_status_label ?? 'Diproses Gudang Reimbursement' }}</BaseBadge>
          </td>
        </tr>
      </template>
    </Datatable>
  </BaseWrapper>
</template>

<script>
import OrderCodeLabel from '../../../../../components/order/order-code-label.vue';
import OrderDateLabel from '../../../../../components/order/order-date-label.vue';
import { requestMixin } from '../../../../../mixins/request/request.js';

export default {
  mixins: [requestMixin],
  components: { OrderCodeLabel, OrderDateLabel },
  data() {
    return {
      orders: {
        data: [],
        included: []
      },
      loading: true,
      filter: {
        status: 'diproses_gudang_pengeluaran'
      }
    }
  },
  computed: {
    columns() {
      return [
        { id: 'order_code', name: 'No. Faktur' },
        { id: 'office_code', name: 'Kode Kantor' },
        { id: 'reimbursement_qty', name: 'Jumlah Barang' },
        { id: 'status', name: 'Status', theadClass: 'text-center' }
      ]
    },
    filterStatus() {
      if (this.filter.status === 'ada_susulan') {
        return {
          'filter[reimbursement_status_in]': 'ada_susulan,susulan_dikemas,susulan_diproses_pengiriman,susulan_dikirim'
        }
      }

      if (this.filter.status === 'diproses_gudang_pengeluaran') {
        return {
          'filter[reimbursement_status_not_in]': 'diproses_gudang_pengiriman,ada_susulan,susulan_dikemas,susulan_diproses_pengiriman,susulan_dikirim,selesai',
        }
      }

      return {
        'filter[reimbursement_status]': this.filter.status
      }
    }
  },
  methods: {
    getOrder(simpleOrder) {
      return this.getSingleIncluded(this.orders, simpleOrder.relationships.order.data.id)
    },
    async loadOrders() {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/orders`, {
        params: {
          'include': 'order',
          'filter[need_reimbursement]': true,
          'fields[simple-orders]': 'order,createdAt',
          'fields[orders]': 'origin_code,order_type,destination_code,origin_office_code,reimbursement_qty,reimbursement_status,reimbursement_status_label',
          ...this.filterStatus
        }
      })

      if (!err) {
        this.orders = res
      }

      this.loading = false
    }
  },
  created() {
    this.loadOrders()
  }
}
</script>